import { render, staticRenderFns } from "./IntegrationTypes.vue?vue&type=template&id=636b033e&scoped=true"
import script from "./IntegrationTypes.vue?vue&type=script&lang=js"
export * from "./IntegrationTypes.vue?vue&type=script&lang=js"
import style0 from "./IntegrationTypes.vue?vue&type=style&index=0&id=636b033e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b033e",
  null
  
)

export default component.exports